module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter":"Filter","deselectFilter":"Deselect filter"},"ja":{"filter":"絞り込む","deselectFilter":"絞り込み解除"},"zh-hant":{"filter":"過濾","deselectFilter":"取消過濾"},"zh-hans":{"filter":"过滤","deselectFilter":"取消过滤"}}')
  delete Component.options._Ctor
}
